<template>
  <zh-table-page
    ref="tableRef"
    v-bind="{
      title: '服务管理',
      search,
      api,
      afterGetDetail,
      beforeSave,
      ...table,
      ...dialog,
    }"
  >
  </zh-table-page>

</template>
<script>
import {
  defineComponent,
  reactive,
  ref,
  toRefs,
  getCurrentInstance,
  onMounted,
  watch,
  computed,
} from "vue";
import { useRouter } from "vue-router";
import { ElMessageBox } from "element-plus";
import moment from "moment"
export default defineComponent({
  setup() {
    const { proxy } = getCurrentInstance();
    const router = useRouter();
    const tableRef = ref();
    const state = reactive({
      search: [
        {
          label: "服务名称",
          placeholder: "服务名称",
          value: "serviceName",
        },
        {
          component: "zh-select",
          label: "服务器",
          placeholder: "服务器",
          value: "serverId",
          url:"postServerList",
            field: {
              id: "value",
              serverName: "label",
            },
            params: {
              serverType: 3,
            },
         
        },
       
      ],
      api: {
        list: "postzhServicePage",
        delete: "deletezhServiceDelete",
        add: "postzhServiceSave",
        edit: "postzhServiceUpdate",
        detail: "getzhService",
        tree: "",
      },
      table: {
        columns: [
          { label: "服务名称", prop: "serviceName" },
          { label: "备份方式", prop: "backupMode" },
          { label: "服务状态", prop: "serviceStatus", width: "110",
          scopeFun: (scope) => {
            if (scope.row.serviceStatus) {
              return scope.row.serviceStatus.desc;
            }
            return '--'

          },
          },
          { label: "部署方式", prop: "deploymentMethods", width: "110",
          scopeFun: (scope) => {
            if (scope.row.deploymentMethods) {
              return scope.row.deploymentMethods.desc;
            }
            return '--'
          }, },
          { label: "备份路径", prop: "backupPath",},
          { label: "数据路径", prop: "dataPath"},
          { label: "占用端口号", prop: "occupiedPort"},
          { label: "占用硬盘", prop: "serviceSize"},
         
        ],
        operations: [
         
          { label: "编辑" },
          { label: "删除", type: "danger" },
        ],
        rowKey: "id",
      },
      dialog: {
        dialogForm: [
          {
            label: "服务名称",
            placeholder: "请输入服务名称",
            value: "serviceName",
          },
          {
            component: "zh-select",
            label: "服务器",
            placeholder: "请选择服务器",
            value: "serverId",
            url:"postServerList",
            field: {
              id: "value",
              serverName: "label",
            },
            // params: {
            //   serverType: 3,
            // },
          
          },
          {
            label: "备份方式",
            placeholder: "请输入备份方式",
            value: "backupMode",
          },
          {
            component: "zh-select",
            label: "服务状态",
            placeholder: "请选择服务状态",
            value: "serviceStatus",
            defaultValue:1,
            options:[
              {value:1,label:'部署'},
              {value:0,label:'未部署 '},
            ],
          },
          {
            component: "zh-select",
            label: "部署方式",
            placeholder: "请选择部署方式",
            value: "deploymentMethods",
            defaultValue:1,
            options:[
              {value:1,label:'容器 '},
              {value:0,label:'非容器 '},
            ],
          },
          {
            label: "备份路径",
            placeholder: "请输入备份路径",
            value: "backupPath",
          },
          {
            label: "数据路径",
            placeholder: "请输入数据路径",
            value: "dataPath",
          },
          {
            label: "占用端口号",
            placeholder: "请输入占用端口号",
            value: "occupiedPort",
          },
          {
            label: "占用硬盘	",
            placeholder: "请输入占用硬盘",
            value: "serviceSize",
          },
        ],
        dialogRules: {
          serviceName: [
            { required: true, message: "服务名称不能为空", trigger: "blur" },
          ],
          serverId: [
            { required: true, message: "请选择服务器", trigger: "blur" },
          ],
          occupiedPort: [
            { required: true, message: "占用端口号不能为空", trigger: "blur" },
          ],
          serviceSize: [
            { required: true, message: "占用硬盘不能为空", trigger: "blur" },
          ],
          publicIp: [
            { required: true, message: "内网ip不能为空", trigger: "blur" },
          ],
          hardDisk: [
            { required: true, message: "硬盘总量不能为空", trigger: "blur" },
          ],
          belongId: [
            { required: true, message: "belongId不能为空", trigger: "blur" },
          ],
          serverId: [
            { required: true, message: "请选择服务器", trigger: "blur" },
          ],
          expirationTime: [
            { required: true, message: "到期时间不能为空", trigger: "blur" },
          ],
         
        },
      },
    });
    onMounted(() => {
    });
    //点击编辑处理详情数据
    const afterGetDetail = (data) => {
      return {
        ...data,
        deploymentMethods: data.deploymentMethods?.value ?? 1,
        serviceStatus: data.serviceStatus?.value ?? 1,
      };
    };
    //新增编辑保存之前
    const beforeSave = (form)=>{
      return {
        ...form,
      }
    }

    return {
      ...toRefs(state),
      tableRef,
      afterGetDetail,
      beforeSave,
    };
  },
});
</script>
